document.addEventListener("DOMContentLoaded", (event) => {
	const tabsContainer = document.querySelectorAll(".et_pb_tabs");

	if (tabsContainer && tabsContainer.length > 0) {
		tabsContainer.forEach((container) => {
			const tabTitleHasIcon = container.dataset.headerImage;
			if (tabTitleHasIcon !== "true") return;

			const tabTitles = container.querySelectorAll(".et_pb_tabs_controls .et_pb_tab_nav_item_link");
			const tabTitleImages = container.querySelectorAll(".et_pb_all_tabs .et_pb_tab_content .tab-title-image ");
			const tabContents = container.querySelectorAll(".et_pb_all_tabs .et_pb_tab_content");
			const tabLIs = container.querySelectorAll(".et_pb_tabs_controls li");

			tabTitles.forEach((title, idx) => {
				title.prepend(tabTitleImages[idx]);
			});

			/**
			 * Duplicate content to create accordion on mobile
			 */
			tabLIs.forEach((li, idx) => {
				const clonedContent = tabContents[idx].cloneNode(true);
				li.appendChild(clonedContent);
				tabLIs[0].classList.add("mobile-active");
				// Add class for active tab in mobile
				const link = li.querySelector("& > a");
				link.addEventListener("click", (e) => {
					e.preventDefault();
					const currentItemId = idx;
					[...tabLIs].filter((l, id) => id !== currentItemId).forEach((l) => l.classList.remove("mobile-active"));

					li.classList.toggle("mobile-active");
				});
			});
		});
	}
});
